module.exports = __webpack_public_path__ + "img/vip5.47bc94f3.png";